import { Component, Input, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { MenuStore } from '../../../menus/service/menu.store';
import { SummaryRecordTypeEnum } from '../../models/summary-record-type.enum';
import { RouteUtils } from '../../utils/route-utils';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { EventUtils } from '../../utils/event-utils';
import { Party } from 'app/event/models/party';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Component({
  selector: 'pioneer-vendor-overview-card',
  templateUrl: './vendor-overview-card.component.html',
  styleUrls: ['./vendor-overview-card.component.css']
})
export class VendorOverviewCardComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public headerRecordType: SummaryRecordTypeEnum;

  @Input() vendors: Party[];

  @Input() vendor: Party;

  public imagesUrl= '';

  constructor(private eventStore: EventStore,
              private menuStore: MenuStore,
              private route: ActivatedRoute,
              private authenticationSore: AuthenticationStore,
              private flashMessagesService: FlashMessagesService,
              private environment: EnvironmentConfiguration
  ) { }

  ngOnInit() {
    this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;

    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
    if (this.onyxEvent) {
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationSore.isAgencyUser()),
        this.onyxEvent.eventProperty.subscriber);
    }

    // If the event property is subscribed, reservations are retrieved to build the overview.
    // Otherwise, RSVPs are
    if (this.onyxEvent && this.vendor.subscriber) {
      this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
    } else {
      this.headerRecordType = SummaryRecordTypeEnum.RSVP;
    }

    if (this.vendors) {
      if (this.vendors.length === 1) {
        this.vendor.isExpanded = true;
      }
    }

    // toggle page to editable if the URL ends with "edit" (it will default to read only)
    // otherwise, check if we need to show a warning flash message when in view modeFD
    RouteUtils.getLastUrlSegment(this.route)
      .subscribe(lastSegment => {
        if (this.authenticationSore.hasPermission('EditEvent') && !this.isEventValid()) {
          this.flashMessagesService.warn('EVENT.EVENT_MISSING_INFO',
            null,
            { hrefValue: `/#/event/${this.onyxEvent.eventId}/summary/edit` });
        }
      });

  }

  isEventValid(): boolean {
    return EventUtils.isEventValid(this.onyxEvent, this.authenticationSore.isAgencyUser());
  }

  public onCardExpandClicked(event: Event, eventPartyId: number
                           , chain: string, brand: string, propertyId: string, expanded: boolean): void {
    event.preventDefault();
    if (eventPartyId) {
      this.vendors.filter(ve => ve.eventPartyId === eventPartyId).forEach(x => {
        x.isExpanded = expanded;
      });
    } else {
      this.vendors.filter(ve => ve.chain === chain && ve.brand === brand && ve.propertyId === propertyId).forEach(x => {
        x.isExpanded = expanded;
      });
    }
    if (expanded && this.vendors.length > 1) {
      this.disableOthers(eventPartyId, chain, brand, propertyId);
    }
  }

  private disableOthers(eventPartyId: number, chain: string, brand: string, propertyId: string): void {
    if (eventPartyId) {
      this.vendors.filter(ve => ve.eventPartyId !== eventPartyId).forEach(x => {
        x.isExpanded = false;
      });
    } else {
      this.vendors.filter(ve => ve.chain !== chain || ve.brand !== brand || ve.propertyId !== propertyId).forEach(x => {
        x.isExpanded = false;
      });
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/vendor-overview-card/vendor-overview-card.component.ts